/*eslint-disable*/
import { Animation, TabFooter, ButtonsContainer, Button } from 'styling/GlobalStyles'
import { CancelBtn } from 'components/Button/CancelBtn'
import { IEmployeesTabWithValidation } from 'types/users.interface'

export const EmployeeWelfareTab = ({
    handleSubmit,
}: IEmployeesTabWithValidation) => {
    return <Animation>
        <TabFooter  >
            <ButtonsContainer>
                <CancelBtn />
                <Button orange onClick={handleSubmit}>
                    Save
                </Button>
            </ButtonsContainer>
        </TabFooter>
    </Animation>
}